import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=71fe13a0&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=ts"
export * from "./Feed.vue?vue&type=script&lang=ts"
import style0 from "./Feed.vue?vue&type=style&index=0&id=71fe13a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe13a0",
  null
  
)

export default component.exports